/* eslint-disable max-len */
import React from "react";

import type { CheckboxSize } from ".";

import styles from "./NoteCheckbox.module.css";

export function SquareCheckboxDashedBorder({ size }: { size: CheckboxSize }) {
	switch (size) {
		case "large": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="19"
					height="19"
					viewBox="0 0 19 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.background}
						d="M4.4 2.75C3.48873 2.75 2.75 3.48873 2.75 4.4V5.08C2.75 5.49421 2.41421 5.83 2 5.83V7.15625C2.41421 7.15625 2.75 7.49204 2.75 7.90625V11.0938C2.75 11.508 2.41421 11.8438 2 11.8438V13.17C2.41421 13.17 2.75 13.5058 2.75 13.92V14.6C2.75 15.5113 3.48873 16.25 4.4 16.25H5.08C5.4934 16.25 5.82868 16.5845 5.83 16.9976H7.15625C7.15757 16.5845 7.49285 16.25 7.90625 16.25H11.0938C11.5071 16.25 11.8424 16.5845 11.8437 16.9976H13.17C13.1713 16.5845 13.5066 16.25 13.92 16.25H14.6C15.5113 16.25 16.25 15.5113 16.25 14.6V13.92C16.25 13.5058 16.5858 13.17 17 13.17V11.8438C16.5858 11.8438 16.25 11.508 16.25 11.0938V7.90625C16.25 7.49204 16.5858 7.15625 17 7.15625V5.83C16.5858 5.83 16.25 5.49421 16.25 5.08V4.4C16.25 3.48873 15.5113 2.75 14.6 2.75H13.92C13.5058 2.75 13.17 2.41421 13.17 2L13.17 1.99756H11.8437L11.8438 2C11.8438 2.41421 11.508 2.75 11.0938 2.75H7.90625C7.49204 2.75 7.15625 2.41421 7.15625 2L7.15625 1.99756H5.83L5.83 2C5.83 2.41421 5.49421 2.75 5.08 2.75H4.4Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2.75 4.4C2.75 3.48873 3.48873 2.75 4.4 2.75H5.08C5.49421 2.75 5.83 2.41421 5.83 2C5.83 1.58579 5.49421 1.25 5.08 1.25H4.4C2.6603 1.25 1.25 2.6603 1.25 4.4V5.08C1.25 5.49421 1.58579 5.83 2 5.83C2.41421 5.83 2.75 5.49421 2.75 5.08V4.4ZM13.92 1.25C13.5058 1.25 13.17 1.58579 13.17 2C13.17 2.41421 13.5058 2.75 13.92 2.75H14.6C15.5113 2.75 16.25 3.48873 16.25 4.4V5.08C16.25 5.49421 16.5858 5.83 17 5.83C17.4142 5.83 17.75 5.49421 17.75 5.08V4.4C17.75 2.6603 16.3397 1.25 14.6 1.25H13.92ZM2.75 13.92C2.75 13.5058 2.41421 13.17 2 13.17C1.58579 13.17 1.25 13.5058 1.25 13.92V14.6C1.25 16.3397 2.6603 17.75 4.4 17.75H5.08C5.49421 17.75 5.83 17.4142 5.83 17C5.83 16.5858 5.49421 16.25 5.08 16.25H4.4C3.48873 16.25 2.75 15.5113 2.75 14.6V13.92ZM17.75 13.92C17.75 13.5058 17.4142 13.17 17 13.17C16.5858 13.17 16.25 13.5058 16.25 13.92V14.6C16.25 15.5113 15.5113 16.25 14.6 16.25H13.92C13.5058 16.25 13.17 16.5858 13.17 17C13.17 17.4142 13.5058 17.75 13.92 17.75H14.6C16.3397 17.75 17.75 16.3397 17.75 14.6V13.92ZM7.90625 1.25C7.49204 1.25 7.15625 1.58579 7.15625 2C7.15625 2.41421 7.49204 2.75 7.90625 2.75H11.0938C11.508 2.75 11.8438 2.41421 11.8438 2C11.8438 1.58579 11.508 1.25 11.0938 1.25H7.90625ZM2.75 7.90625C2.75 7.49204 2.41421 7.15625 2 7.15625C1.58579 7.15625 1.25 7.49204 1.25 7.90625V11.0938C1.25 11.508 1.58579 11.8438 2 11.8438C2.41421 11.8438 2.75 11.508 2.75 11.0938V7.90625ZM17.75 7.90625C17.75 7.49204 17.4142 7.15625 17 7.15625C16.5858 7.15625 16.25 7.49204 16.25 7.90625V11.0938C16.25 11.508 16.5858 11.8438 17 11.8438C17.4142 11.8438 17.75 11.508 17.75 11.0938V7.90625ZM7.90625 16.25C7.49204 16.25 7.15625 16.5858 7.15625 17C7.15625 17.4142 7.49204 17.75 7.90625 17.75H11.0938C11.508 17.75 11.8438 17.4142 11.8438 17C11.8438 16.5858 11.508 16.25 11.0938 16.25H7.90625Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M14.4231 5.75269C14.7793 6.09931 14.7872 6.66911 14.4405 7.02536L8.40368 13.2299C8.06135 13.5817 7.50022 13.5944 7.14243 13.2583L4.58837 10.8591C4.22609 10.5188 4.20828 9.9492 4.54859 9.58691C4.88891 9.22463 5.45848 9.20682 5.82076 9.54713L7.73026 11.3408L13.1504 5.77012C13.497 5.41387 14.0668 5.40606 14.4231 5.75269Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="5.5"
						y="8.59796"
						width="8"
						height="1.80408"
						rx="0.902039"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
		case "medium": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.background}
						d="M2.625 3.5C2.625 3.01675 3.01675 2.625 3.5 2.625H4.13636C4.48154 2.625 4.76136 2.34518 4.76136 2H5.73864C5.73864 2.34518 6.01846 2.625 6.36364 2.625H7.63636C7.98154 2.625 8.26136 2.34518 8.26136 2H9.23864C9.23864 2.34518 9.51846 2.625 9.86364 2.625H10.5C10.9832 2.625 11.375 3.01675 11.375 3.5V4.13636C11.375 4.48154 11.6548 4.76136 12 4.76136V5.73864C11.6548 5.73864 11.375 6.01846 11.375 6.36364V7.63636C11.375 7.98154 11.6548 8.26136 12 8.26136V9.23864C11.6548 9.23864 11.375 9.51846 11.375 9.86364V10.5C11.375 10.9832 10.9832 11.375 10.5 11.375H9.86364C9.51846 11.375 9.23864 11.6548 9.23864 12H8.26136C8.26136 11.6548 7.98154 11.375 7.63636 11.375H6.36364C6.01846 11.375 5.73864 11.6548 5.73864 12H4.76136C4.76136 11.6548 4.48154 11.375 4.13636 11.375H3.5C3.01675 11.375 2.625 10.9832 2.625 10.5V9.86364C2.625 9.51846 2.34518 9.23864 2 9.23864V8.26136C2.34518 8.26136 2.625 7.98154 2.625 7.63636V6.36364C2.625 6.01846 2.34518 5.73864 2 5.73864V4.76136C2.34518 4.76136 2.625 4.48154 2.625 4.13636V3.5Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M3.5 2.625C3.01675 2.625 2.625 3.01675 2.625 3.5V4.13636C2.625 4.48154 2.34518 4.76136 2 4.76136C1.65482 4.76136 1.375 4.48154 1.375 4.13636V3.5C1.375 2.32639 2.3264 1.375 3.5 1.375H4.13636C4.48154 1.375 4.76136 1.65482 4.76136 2C4.76136 2.34518 4.48154 2.625 4.13636 2.625H3.5ZM5.73864 2C5.73864 1.65482 6.01846 1.375 6.36364 1.375H7.63636C7.98154 1.375 8.26136 1.65482 8.26136 2C8.26136 2.34518 7.98154 2.625 7.63636 2.625H6.36364C6.01846 2.625 5.73864 2.34518 5.73864 2ZM9.23864 2C9.23864 1.65482 9.51846 1.375 9.86364 1.375H10.5C11.6736 1.375 12.625 2.3264 12.625 3.5V4.13636C12.625 4.48154 12.3452 4.76136 12 4.76136C11.6548 4.76136 11.375 4.48154 11.375 4.13636V3.5C11.375 3.01675 10.9832 2.625 10.5 2.625H9.86364C9.51846 2.625 9.23864 2.34518 9.23864 2ZM2 5.73864C2.34518 5.73864 2.625 6.01846 2.625 6.36364V7.63636C2.625 7.98154 2.34518 8.26136 2 8.26136C1.65482 8.26136 1.375 7.98154 1.375 7.63636V6.36364C1.375 6.01846 1.65482 5.73864 2 5.73864ZM12 5.73864C12.3452 5.73864 12.625 6.01846 12.625 6.36364V7.63636C12.625 7.98154 12.3452 8.26136 12 8.26136C11.6548 8.26136 11.375 7.98154 11.375 7.63636V6.36364C11.375 6.01846 11.6548 5.73864 12 5.73864ZM2 9.23864C2.34518 9.23864 2.625 9.51846 2.625 9.86364V10.5C2.625 10.9832 3.01675 11.375 3.5 11.375H4.13636C4.48154 11.375 4.76136 11.6548 4.76136 12C4.76136 12.3452 4.48154 12.625 4.13636 12.625H3.5C2.32639 12.625 1.375 11.6736 1.375 10.5V9.86364C1.375 9.51846 1.65482 9.23864 2 9.23864ZM12 9.23864C12.3452 9.23864 12.625 9.51846 12.625 9.86364V10.5C12.625 11.6736 11.6736 12.625 10.5 12.625H9.86364C9.51846 12.625 9.23864 12.3452 9.23864 12C9.23864 11.6548 9.51846 11.375 9.86364 11.375H10.5C10.9832 11.375 11.375 10.9832 11.375 10.5V9.86364C11.375 9.51846 11.6548 9.23864 12 9.23864ZM5.73864 12C5.73864 11.6548 6.01846 11.375 6.36364 11.375H7.63636C7.98154 11.375 8.26136 11.6548 8.26136 12C8.26136 12.3452 7.98154 12.625 7.63636 12.625H6.36364C6.01846 12.625 5.73864 12.3452 5.73864 12Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10.1693 4.57786C10.4167 4.81858 10.4222 5.21427 10.1814 5.46167L6.3398 9.41001C6.10208 9.65434 5.7124 9.6631 5.46394 9.4297L3.83863 7.90295C3.58704 7.66662 3.57467 7.27109 3.811 7.0195C4.04734 6.76791 4.44287 6.75555 4.69446 6.99188L5.87216 8.09816L9.28553 4.58997C9.52624 4.34257 9.92193 4.33715 10.1693 4.57786Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="4"
						y="6.37595"
						width="6"
						height="1.24811"
						rx="0.624054"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
		case "small": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="12"
					height="12"
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.background}
						opacity="0.1"
						d="M1.85003 2.75003C1.85003 2.25297 2.25297 1.85003 2.75003 1.85003H3.29169C3.62306 1.85003 3.89169 1.5814 3.89169 1.25003C3.89169 1.25002 3.89169 1.25003 3.89169 1.25003L4.85836 1.25C4.85836 1.25001 4.85836 1.24999 4.85836 1.25C4.85836 1.58137 5.12699 1.85003 5.45836 1.85003H6.54169C6.87306 1.85003 7.14169 1.5814 7.14169 1.25003C7.14169 1.25002 7.14169 1.25003 7.14169 1.25003L8.10836 1.25C8.10836 1.25001 8.10836 1.24999 8.10836 1.25C8.10836 1.58137 8.37699 1.85003 8.70836 1.85003H9.25003C9.74708 1.85003 10.15 2.25297 10.15 2.75003V3.29169C10.15 3.62306 10.4186 3.89168 10.75 3.89169V4.85836C10.4186 4.85837 10.15 5.127 10.15 5.45836V6.54169C10.15 6.87306 10.4186 7.14168 10.75 7.14169V8.10836C10.4186 8.10837 10.15 8.377 10.15 8.70836V9.25003C10.15 9.74708 9.74708 10.15 9.25003 10.15H8.70836C8.377 10.15 8.10837 10.4186 8.10836 10.75H7.14169C7.14168 10.4186 6.87306 10.15 6.54169 10.15H5.45836C5.127 10.15 4.85837 10.4186 4.85836 10.75H3.89169C3.89168 10.4186 3.62306 10.15 3.29169 10.15H2.75003C2.25297 10.15 1.85003 9.74708 1.85003 9.25003V8.70836C1.85003 8.37699 1.5814 8.10836 1.25003 8.10836C1.25002 8.10836 1.25003 8.10836 1.25003 8.10836L1.25 7.14169C1.25001 7.14169 1.24999 7.14169 1.25 7.14169C1.58137 7.14169 1.85003 6.87306 1.85003 6.54169V5.45836C1.85003 5.12699 1.5814 4.85836 1.25003 4.85836C1.25002 4.85836 1.25003 4.85836 1.25003 4.85836L1.25 3.89169C1.25001 3.89169 1.24999 3.89169 1.25 3.89169C1.58137 3.89169 1.85003 3.62306 1.85003 3.29169V2.75003Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2.75002 1.85002C2.25297 1.85002 1.85002 2.25297 1.85002 2.75002V3.29169C1.85002 3.62306 1.5814 3.89169 1.25002 3.89169C0.918654 3.89169 0.650024 3.62306 0.650024 3.29169V2.75002C0.650024 1.59023 1.59023 0.650024 2.75002 0.650024H3.29169C3.62306 0.650024 3.89169 0.918654 3.89169 1.25002C3.89169 1.5814 3.62306 1.85002 3.29169 1.85002H2.75002ZM4.85836 1.25002C4.85836 0.918654 5.12699 0.650024 5.45836 0.650024H6.54169C6.87306 0.650024 7.14169 0.918654 7.14169 1.25002C7.14169 1.5814 6.87306 1.85002 6.54169 1.85002H5.45836C5.12699 1.85002 4.85836 1.5814 4.85836 1.25002ZM8.10836 1.25002C8.10836 0.918654 8.37699 0.650024 8.70836 0.650024H9.25002C10.4098 0.650024 11.35 1.59023 11.35 2.75002V3.29169C11.35 3.62306 11.0814 3.89169 10.75 3.89169C10.4187 3.89169 10.15 3.62306 10.15 3.29169V2.75002C10.15 2.25297 9.74708 1.85002 9.25002 1.85002H8.70836C8.37699 1.85002 8.10836 1.5814 8.10836 1.25002ZM1.25002 4.85836C1.5814 4.85836 1.85002 5.12699 1.85002 5.45836V6.54169C1.85002 6.87306 1.5814 7.14169 1.25002 7.14169C0.918654 7.14169 0.650024 6.87306 0.650024 6.54169V5.45836C0.650024 5.12699 0.918654 4.85836 1.25002 4.85836ZM10.75 4.85836C11.0814 4.85836 11.35 5.12699 11.35 5.45836V6.54169C11.35 6.87306 11.0814 7.14169 10.75 7.14169C10.4187 7.14169 10.15 6.87306 10.15 6.54169V5.45836C10.15 5.12699 10.4187 4.85836 10.75 4.85836ZM1.25002 8.10836C1.5814 8.10836 1.85002 8.37699 1.85002 8.70836V9.25002C1.85002 9.74708 2.25297 10.15 2.75002 10.15H3.29169C3.62306 10.15 3.89169 10.4187 3.89169 10.75C3.89169 11.0814 3.62306 11.35 3.29169 11.35H2.75002C1.59023 11.35 0.650024 10.4098 0.650024 9.25002V8.70836C0.650024 8.37699 0.918654 8.10836 1.25002 8.10836ZM10.75 8.10836C11.0814 8.10836 11.35 8.37699 11.35 8.70836V9.25002C11.35 10.4098 10.4098 11.35 9.25002 11.35H8.70836C8.37699 11.35 8.10836 11.0814 8.10836 10.75C8.10836 10.4187 8.37699 10.15 8.70836 10.15H9.25002C9.74708 10.15 10.15 9.74708 10.15 9.25002V8.70836C10.15 8.37699 10.4187 8.10836 10.75 8.10836ZM4.85836 10.75C4.85836 10.4187 5.12699 10.15 5.45836 10.15H6.54169C6.87306 10.15 7.14169 10.4187 7.14169 10.75C7.14169 11.0814 6.87306 11.35 6.54169 11.35H5.45836C5.12699 11.35 4.85836 11.0814 4.85836 10.75Z"
						fill="var(--vividRoyal)"
					/>{" "}
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M8.93585 3.7465C9.18325 3.98722 9.18867 4.38291 8.94796 4.63031L5.43444 8.24142C5.19671 8.48575 4.80704 8.49451 4.55857 8.26111L3.07209 6.86476C2.8205 6.62843 2.80813 6.23289 3.04446 5.98131C3.2808 5.72972 3.67633 5.71735 3.92792 5.95368L4.96679 6.92957L8.05205 3.75861C8.29276 3.51121 8.68845 3.50579 8.93585 3.7465Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="3"
						y="5.37598"
						width="6"
						height="1.24811"
						rx="0.624054"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
	}
}

export function SquareCheckboxSolidBorder({ size }: { size: CheckboxSize }) {
	switch (size) {
		case "large": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="19"
					height="19"
					viewBox="0 0 19 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1.25 4.27276C1.25 2.60335 2.60332 1.25003 4.27273 1.25003H14.7273C16.3967 1.25003 17.75 2.60335 17.75 4.27276V14.7273C17.75 16.3967 16.3967 17.75 14.7273 17.75H4.27273C2.60332 17.75 1.25 16.3967 1.25 14.7273V4.27276ZM4.27273 2.75003C3.43175 2.75003 2.75 3.43178 2.75 4.27276V14.7273C2.75 15.5683 3.43175 16.25 4.27273 16.25H14.7273C15.5683 16.25 16.25 15.5683 16.25 14.7273V4.27276C16.25 3.43178 15.5683 2.75003 14.7273 2.75003H4.27273Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.background}
						d="M2.75 4.27273C2.75 3.43175 3.43175 2.75 4.27273 2.75H14.7273C15.5683 2.75 16.25 3.43175 16.25 4.27273V14.7273C16.25 15.5683 15.5683 16.25 14.7273 16.25H4.27273C3.43175 16.25 2.75 15.5683 2.75 14.7273V4.27273Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M14.4231 5.75269C14.7793 6.09931 14.7872 6.66911 14.4405 7.02536L8.40368 13.2299C8.06135 13.5817 7.50022 13.5944 7.14243 13.2583L4.58837 10.8591C4.22609 10.5188 4.20828 9.9492 4.54859 9.58691C4.88891 9.22463 5.45848 9.20682 5.82076 9.54713L7.73026 11.3408L13.1504 5.77012C13.497 5.41387 14.0668 5.40606 14.4231 5.75269Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="5.5"
						y="8.59796"
						width="8"
						height="1.80408"
						rx="0.902039"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
		case "medium": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10.1693 4.57786C10.4167 4.81858 10.4222 5.21427 10.1814 5.46167L6.3398 9.41001C6.10208 9.65434 5.7124 9.6631 5.46394 9.4297L3.83863 7.90295C3.58704 7.66662 3.57467 7.27109 3.811 7.0195C4.04734 6.76791 4.44287 6.75555 4.69446 6.99188L5.87216 8.09816L9.28553 4.58997C9.52624 4.34257 9.92193 4.33715 10.1693 4.57786Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="4"
						y="6.37595"
						width="6"
						height="1.24811"
						rx="0.624054"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1.375 3.50003C1.375 2.32643 2.3264 1.37503 3.5 1.37503H10.5C11.6736 1.37503 12.625 2.32643 12.625 3.50003V10.5C12.625 11.6736 11.6736 12.625 10.5 12.625H3.5C2.32639 12.625 1.375 11.6736 1.375 10.5V3.50003ZM3.5 2.62503C3.01675 2.62503 2.625 3.01678 2.625 3.50003V10.5C2.625 10.9833 3.01675 11.375 3.5 11.375H10.5C10.9832 11.375 11.375 10.9833 11.375 10.5V3.50003C11.375 3.01678 10.9832 2.62503 10.5 2.62503H3.5Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.background}
						d="M2.625 3.5C2.625 3.01675 3.01675 2.625 3.5 2.625H10.5C10.9832 2.625 11.375 3.01675 11.375 3.5V10.5C11.375 10.9832 10.9832 11.375 10.5 11.375H3.5C3.01675 11.375 2.625 10.9832 2.625 10.5V3.5Z"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
		case "small": {
			return (
				<svg
					className={styles.checkboxSvg}
					width="12"
					height="12"
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						className={styles.background}
						d="M1.875 2.75C1.875 2.26675 2.26675 1.875 2.75 1.875H9.25C9.73325 1.875 10.125 2.26675 10.125 2.75V9.25C10.125 9.73325 9.73325 10.125 9.25 10.125H2.75C2.26675 10.125 1.875 9.73325 1.875 9.25V2.75Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.box}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M0.625 2.75C0.625 1.57639 1.5764 0.625 2.75 0.625H9.25C10.4236 0.625 11.375 1.5764 11.375 2.75V9.25C11.375 10.4236 10.4236 11.375 9.25 11.375H2.75C1.57639 11.375 0.625 10.4236 0.625 9.25V2.75ZM2.75 1.875C2.26675 1.875 1.875 2.26675 1.875 2.75V9.25C1.875 9.73325 2.26675 10.125 2.75 10.125H9.25C9.73325 10.125 10.125 9.73325 10.125 9.25V2.75C10.125 2.26675 9.73325 1.875 9.25 1.875H2.75Z"
						fill="var(--vividRoyal)"
					/>
					<path
						className={styles.checkmark}
						fillRule="evenodd"
						clipRule="evenodd"
						d="M8.93585 3.7465C9.18325 3.98722 9.18867 4.38291 8.94796 4.63031L5.43444 8.24142C5.19671 8.48575 4.80704 8.49451 4.55857 8.26111L3.07209 6.86476C2.8205 6.62843 2.80813 6.23289 3.04446 5.98131C3.2808 5.72972 3.67633 5.71735 3.92792 5.95368L4.96679 6.92957L8.05205 3.75861C8.29276 3.51121 8.68845 3.50579 8.93585 3.7465Z"
						fill="var(--vividRoyal)"
					/>
					<rect
						className={styles.indeterminateMark}
						x="3"
						y="5.37598"
						width="6"
						height="1.24811"
						rx="0.624054"
						fill="var(--vividRoyal)"
					/>
				</svg>
			);
		}
	}
}
